import { Row, Form, Modal, Col, Radio, Select, notification, Input } from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import { } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { GenderOptions, getGenderName } from '../../models/user'
import {
  getSourceTypeName,
  RegistrationCategory,
  SourceTypeCategories,
} from '../../models/registration'
import styles from './Retail.module.css'
import { selectEdition, selectInsuranceArray, selectTenantCategory, selectUserId } from '../../app/applicationSlice'
import { MedicelListValue } from '../../models/setting'
import { getUserProfileList, saveSetting } from '../personalManagement/personalDetail/personalDetailSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import { Checks, Settinglable } from '../../models/personalSetting'
import _ from 'lodash'

export const RetailPreferencesSettingModal = (props: {
  visible: boolean
  onOk: () => void
  onCancel: () => void
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const insuranceArray = useSelector(selectInsuranceArray)

  const tenantCategory = useSelector(selectTenantCategory)

  const [form] = Form.useForm()

  const userId = useSelector(selectUserId)

  const { Option } = Select

  const hisVersion = useSelector(selectEdition) //his版本 0通用 1口腔

  const localData: any = JSON.parse(
    localStorage.getItem('retailPreferencesSettingData') || '{}'
  )

  useEffect(() => {
    const completionType = `completionType_${userId}`
    if (props?.visible) {
      return
    } else {
      localStorage.setItem(
        'retailPreferencesSettingData',
        JSON.stringify({
          ...localData,
          sex: localData?.sex ? Number(localData?.sex) : 0,
          recipeType: localData?.recipeType ? Number(localData?.recipeType) : 0,
          [completionType]: localData?.[completionType] ? Number(localData?.[completionType]) : 0,
          tips: localData?.tips ? Number(localData?.tips) : 7,
        })
      )
    }
  }, [props?.visible])

  const getPersonalSettingDetail = () => {
    dispatch(getUserProfileList({ userId: userId, flag: 2 }))
      .then(unwrapResult)
      .then((res: any) => {
        const KSKDGHLX = res?.find((item: any) => item?.code == Checks.KSKDGHLX)?.codeName //挂号类别
        const KSKDHZXB = res?.find((item: any) => item?.code == Checks.KSKDHZXB)?.codeName //患者性别
        const KSKDXZCF = res?.find((item: any) => item?.code == Checks.KSKDXZCF)?.codeName //默认选择处方
        const KSKDKFLX = res?.find((item: any) => item?.code == Checks.KSKDKFLX)?.codeName //开方类型
        const KSKDMRTS = res?.find((item: any) => item?.code == Checks.KSKDMRTS)?.codeName //中药方默认帖数

        const completionType = `completionType_${userId}`
        form.setFieldsValue({
          [Checks.KSKDGHLX]: KSKDGHLX ? KSKDGHLX : localData?.insuranceStatus
            ? localData?.insuranceStatus
            : 'ZIFEI',
          [Checks.KSKDHZXB]: KSKDHZXB ? Number(KSKDHZXB) : localData?.sex ? Number(localData?.sex) : 0,
          [Checks.KSKDXZCF]: KSKDXZCF ? Number(KSKDXZCF) : localData?.recipeType ? Number(localData?.recipeType) : 0,
          [Checks.KSKDKFLX]: KSKDKFLX ? Number(KSKDKFLX) : localData?.[completionType] ? Number(localData?.[completionType]) : 0,
          [Checks.KSKDMRTS]: KSKDMRTS ? Number(KSKDMRTS) : localData?.recipeType ? Number(localData?.tips) : 7,
        })
      })
  }

  useEffect(() => {
    if (props?.visible) {
      getPersonalSettingDetail()
    }
  }, [props?.visible])

  return (
    <>
      <Modal
        title={`快速开单偏好设置`}
        width='500px'
        okText='确定'
        cancelText='取消'
        visible={props.visible}
        onOk={(e) => {
          const completionType = `completionType_${userId}`
          form
            .validateFields()
            .then((values) => {
              // localStorage.setItem(
              //   'retailPreferencesSettingData',
              //   JSON.stringify({ ...localData, ...values, completionType: null, [completionType]: values?.completionType ? values?.completionType : 0, })
              // )
              // 正则匹配 1000–1010 之间的数字（含0）
              const pattern = /^(200[0-9]|2010)$/
              const f = values && _.chain(values)
                .pickBy((_, k) => pattern.test(k))
                .mapValues(
                  (v, k) =>
                  ({
                    code: k,
                    codeName: v,
                    userId: userId,
                  } as Settinglable)
                )
                .values()
                .value()
              dispatch(saveSetting(f))
                .then(unwrapResult)
                .then(() => {
                  form.resetFields()
                  props.onOk()
                  notification.success({
                    message: '保存成功，将再下次进入系统时生效',
                  })
                })
            })
            .catch(() => {
              // Do nothing.
            })

        }}
        onCancel={() => {
          form.resetFields()
          props.onCancel()
        }}
      >
        <Form
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
          form={form}
        >
          <Row
            style={{ marginBottom: 10, width: '100%' }}
            align='middle'
            justify='space-between'
          >
            <Col span={24}>
              <div className={styles.title}>挂号类型 - 选择一个默认项：</div>
              <Col span={24} className={styles.main}>
                <Form.Item
                  label=''
                  name={Checks.KSKDGHLX}
                  initialValue={0}
                  noStyle
                >
                  <Radio.Group>
                    <Radio
                      value={'ZIFEI'}
                      key={RegistrationCategory.SelfPay}
                      onClick={() => {
                        return
                      }}
                    >
                      自费
                    </Radio>
                    {insuranceArray.length > 0 &&
                      insuranceArray.map((v: any) => (
                        <Radio key={JSON.stringify(v)} value={v.insuranceCode}>
                          {v.insuranceName}
                        </Radio>
                      ))}
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Col>
            <Col span={24}>
              <div className={styles.title}>性别 - 选择一个默认项：</div>
              <Col span={24} className={styles.main}>
                <Form.Item label='' name={Checks.KSKDHZXB} initialValue={0} noStyle>
                  <Radio.Group>
                    {GenderOptions?.map((g) => (
                      <Radio key={g} value={g}>
                        {getGenderName(g)}
                      </Radio>
                    ))}
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Col>
            <Col span={24}>
              <div className={styles.title}>默认选择处方：</div>
              <Col span={24} className={styles.main}>
                <Form.Item
                  label=''
                  name={Checks.KSKDXZCF}
                  initialValue={0}
                  noStyle
                >
                  <Radio.Group>
                    <Radio key={0} value={0}>
                      {tenantCategory == 16 ? '治疗' : '西药'}
                    </Radio>
                    {hisVersion == 1 ?
                      <></> :
                      <Radio key={1} value={1}>
                        中药
                      </Radio>}
                    {location?.pathname == '/retail' ?
                      <Radio key={2} value={2}>
                        处置
                      </Radio> :
                      <></> }
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Col>
            <Col span={24}>
              <div className={styles.title}>西药方默认选中开方类型：</div>
              <Col span={24} className={styles.main}>
                <Form.Item
                  label=''
                  name={Checks.KSKDKFLX}
                  initialValue={0}
                  noStyle
                >
                  <Radio.Group>
                    <Radio key={0} value={0}>
                      药品
                    </Radio>
                    <Radio key={1} value={1}>
                      诊疗
                    </Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Col>
            {hisVersion == 0 ? (
              <>
                <Col span={24}>
                  <div className={styles.title}>中药方默认帖数：</div>
                  <Col span={24} className={styles.main}>
                    <Form.Item label='' name={Checks.KSKDMRTS} noStyle>
                      <Input style={{ width: '100px' }}></Input>
                    </Form.Item>
                    <span style={{ marginLeft: '10px' }}>帖</span>
                  </Col>
                </Col>
              </>
            ) : (
              ''
            )}
          </Row>
        </Form>
      </Modal>
    </>
  )
}
